import { createContext } from 'react';

const AppContext = createContext(false);

export default AppContext;
